import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ResultTable from "../../../components/table/ResultTable";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import CheckCSName from "../CheckCSName";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";

export default function SV2({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

function Description({row, settings, globalVariables}) {
    switch (row.error_id) {
        case MessageCodes.Internal.SV02.error_id: {
            return (
                <ResultText>
                    The bridge low chord elevations are not consistent with the survey data at the following {row?.data?.length} bridges.
                    <ResultTable >
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>Bridge</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'left'}}></ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20)}}>Left</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20)}}>Right</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'left'}}></ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {
                                    return (
                                        <>
                                            <ResultRow>
                                                <ResultBodyCell rowSpan={2} style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>
                                                    RS <CheckCSName csName={r?.cross_section} />
                                                </ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>US</ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {r?.us_l_survey?.toFixed(2)}
                                                </ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {ResultCellHighlight(r?.us_l_survey?.toFixed(2), r?.us_l?.toFixed(2))}
                                                </ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {r?.us_r_survey?.toFixed(2)}
                                                </ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {ResultCellHighlight(r?.us_r_survey?.toFixed(2), r?.us_r?.toFixed(2))}
                                                </ResultBodyCell>
                                            </ResultRow>

                                            <ResultRow>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>DS</ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {r?.ds_l_survey?.toFixed(2)}
                                                </ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {ResultCellHighlight(r?.ds_l_survey?.toFixed(2), r?.ds_l?.toFixed(2))}
                                                </ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {r?.ds_r_survey?.toFixed(2)}
                                                </ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                    {ResultCellHighlight(r?.ds_r_survey?.toFixed(2), r?.ds_r?.toFixed(2))}
                                                </ResultBodyCell>
                                            </ResultRow>
                                        </>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </ResultText>
            )
        }
    }
}